export class PayRollMonthDto {
    month?: number;
    years?: number;
    freezStatus?: number;
    department?: string;
    employeeCode?: string;
    empType?: string;
    unitId?: number;
    employeeId?: number;
    constructor(month?: number, years?: number, freezStatus?: number, department?: string, employeeCode?: string, empType?: string, unitId?: number, employeeId?: number) {
        this.month = month;
        this.years = years;
        this.freezStatus = freezStatus;
        this.department = department;
        this.employeeCode = employeeCode;
        this.employeeId = employeeId;
        this.unitId = unitId;
        this.empType = empType;
    }
}